import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import moment from 'moment';
import BCReactComponent from '@bibliocommons/base-bc-react-component';

import CheckedOutStatusIcon from '../CheckedOutStatusIcon';

import './DueDateNotice.scss';

export default class DueDateNotice extends BCReactComponent {
  getDaysAway() {
    const today = moment().startOf('day');
    const days = today.diff(this.props.dueDate, 'days');
    return Math.abs(days);
  }

  isDueToday() {
    return this.getDaysAway() < 1;
  }

  isOneDayAway() {
    const daysAway = this.getDaysAway();
    return daysAway >= 1 && daysAway < 2;
  }

  renderDaysRemaining() {
    const { status, dueDate } = this.props;

    const timeSince = this.isOneDayAway() ?
      <FormattedMessage id="number_of_days" values={{ count: 1 }} /> :
      moment().startOf('day').to(dueDate, true);

    return (
      <FormattedMessage
        id="label_due_date_notice"
        values={{ status, timeSince }} />
    );
  }

  renderDate() {
    const { status, dueDate } = this.props;
    return this.isDueToday() ?
      <FormattedMessage id="due_today" /> :
      this.renderDaysRemaining(status, dueDate);
  }

  render() {
    const { status, dueDate } = this.props;
    return (
      <div className={cn('cp-due-date-notice', status && status.toLowerCase())}>
        <CheckedOutStatusIcon
          status={status}
          withBackground
          withLabel />
        <span className="due-date-notice">
          {dueDate && this.renderDate()}
        </span>
      </div>
    );
  }
}

DueDateNotice.propTypes = {
  status: PropTypes.string,
  dueDate: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/DueDateNotice/DueDateNotice.jsx